export default __webpack_public_path__ + "static/desktop_image-863150378b4aa0a82fd2fab37d8a7a93.png";